import { render, staticRenderFns } from "./AssignmentsDeleteDialog.vue?vue&type=template&id=47618ab6&scoped=true"
import script from "./AssignmentsDeleteDialog.vue?vue&type=script&lang=js"
export * from "./AssignmentsDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47618ab6",
  null
  
)

export default component.exports